








































import {functions, auth} from "@/scripts/firebase";
import { NoticeProps } from "@/scripts/datatypes"
import { ValidationObserver } from 'vee-validate'
import Notice from "@/components/Notice.vue"
import ModalFormPassword from "@/components/ModalFormPassword.vue"
import { Component,Mixins,Watch } from "vue-property-decorator";
import Common from '@/mixins/common';

@Component({
  components: {
    Notice,
    ModalFormPassword
  }
})

/**
 * ユーザー削除は別に実装
 */

export default class Settings extends Mixins(Common) {
  isLoading = false
  theSchoolName = ''
  showModal = false
  notice = {} as NoticeProps

  modal = {
    title: 'settings.deleteSchool',
    message: 'settings.deleleSchoolDescription',
    confirmText: 'settings.deleteSchool',
    isLoading: false
  }
  
  get observer(){
    return this.$refs.settingsValidationObserver as InstanceType<typeof ValidationObserver>;
  }

  get isDisabled(){
    return this.theSchoolName === this.$store.getters.schoolName
  }

  get schoolName(){
    return this.$store.getters.schoolName
  }

  @Watch('schoolName')
  changeSchoolName(val: string){
    this.theSchoolName = val
  }

  async created(){
    console.trace('created');
    this.theSchoolName = this.schoolName

    if(this.$store.getters.numSchools === 1){
      this.modal = {
        title: 'settings.deleteAccount',
        message: 'settings.deleleAccountDescription',
        confirmText: 'settings.deleteAccount',
        isLoading: false
      }
    }
  }
 
 async mounted(){
  console.trace('mounted');
 }

  destroyed() {
    console.trace('destroyed');
  }

  async deleteSchool(password: false | string){
    this.$set(this.modal,'errorMessage','')

    if(password){
      if(this.$store.getters.accessLevel === 10 && this.$store.getters.role === 'superAdmin'){
          this.$store.commit("setLoading",true)
          this.$set(this.modal,'isLoading',true)
          try{
            const user = await this.$reauthenticateWithEmail(this.$store.state.user.email,password)
            const deleteSchool = functions.httpsCallable('deleteSchool');

            const deletedSchool = await deleteSchool({schoolId: this.$store.getters.schoolId});

             try{
              const sendMail = functions.httpsCallable('sendEmail');
              const data = {
                uid: user.uid,
                schoolId: this.$store.getters.schoolId,
                actionType: 'deleteSchool',
                template: 'deleteSchoolMail'
              }

              if(this.$store.getters.numSchools === 1){
                data.actionType = 'deleteAccount'
                data.template = 'deleteAccountMail'
              }

              const sentMail = await sendMail(data);

            }catch(error){
//
            }

            //this.$store.commit("setLoading",false);
            //this.$set(this.modal,'isLoading',false)

            if(this.$store.getters.numSchools === 1){
              await user.delete()
              
              this.$router.push({path: '/',query: { account: 'deleted'}})
            }else if(auth.currentUser){
              await auth.currentUser.getIdToken(true)
            }
            this.showModal = false
            
          }catch(error){
            const errorCode = this.$getErrorCode(error)
            const errorMessage = this.$getErrorMessage(errorCode)
            this.$set(this.modal,'errorMessage',errorMessage)
          }finally{
            this.$store.commit("setLoading",false);
            this.$set(this.modal,'isLoading',false)
          }
      }else{
        this.showModal = false
        this.notice = {
          message: this.$t('settings.notAuthorized') as string,
          isShow: true,
          type: {'is-danger': true}
        }
      }
    }else{
      this.showModal = false
    }
  }

  public async settings() {
    try{
      this.notice = {
        isShow: false,
      }

      if(await this.observer.validate()){
        this.$store.commit("setLoading",true);
        this.isLoading = true

        const data = {
          schoolName: this.theSchoolName,
        }

        const schoolPublicProfileDocRef = this.$getSchoolPublicProfileDocRef()

        await this.$updateDoc(schoolPublicProfileDocRef,data)

        await this.$waitUntilUpdatedForDoc(schoolPublicProfileDocRef)
     
        this.notice = {
          message: this.$t('settings.update') as string,
          duration: 0,
          isShow: true,
          type: {'is-success': true}
        }
        //this.schoolName = ''
        //this.observer.reset()
      }
    }catch(error){
      console.table(error)
      const errorCode = this.$getErrorCode(error)
      const errorMessage0 = this.$t('settings.error') as string

      const errorMessage1 = this.$getErrorMessage(errorCode)

      const errorField = this.$getErrorField(errorCode)

      if(errorMessage1 && errorField){        
        this.observer.setErrors({
         [errorField]: errorMessage1
        })
      }

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }
}
